import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import { UntypedFormControl, AbstractControl } from '@angular/forms';
import * as moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {

  constructor() { }

  chosenYearHandler(normalizedYear: Moment, control: AbstractControl): void {
    const controlValue = control.value ? control.value : new UntypedFormControl(moment()).value;
    controlValue.year(normalizedYear.year());
    control.setValue(controlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, control: AbstractControl, datepicker: MatDatepicker<Moment>): void {
    const controlValue = control.value ? control.value : new UntypedFormControl(moment()).value;
    controlValue.month(normalizedMonth.month());
    control.setValue(controlValue);
    datepicker.close();
  }

  getMonthYearFormat(date: Date) {
    const currentMonth = date.getMonth() + 1;
    const monthFormat = date.getMonth() < 10 ? ('0' + currentMonth) : currentMonth;
    return monthFormat + '/' + date.getFullYear();
  }
}
